import { useState, useEffect } from 'react';
import CONSTANTS from "../constants/constants";

export default function useAllSearchData() {
  const [ loading, setLoading ] = useState(true);
  const [ error, setError ] = useState(null);
  const [ petTypes, setPetTypes ] = useState([]);
  const [ breeds, setBreeds ] = useState([]);
  const [ dietaryGoals, setDietaryGoals ] = useState([]);

  useEffect(() => {
    setLoading(true);
    window.scroll(0,0);
    fetch(`${CONSTANTS.baseUrl}api/truestories/get-search-data`)
    .catch(err => setError(err))
    .then(res => res.json())
    .then(response => {
      setPetTypes(response.data.petTypes);
      setBreeds(response.data.breeds);
      setDietaryGoals(response.data.dietaryGoals);
      setLoading(false)
    });
  }, []);

  return [ loading, error, { petTypes, breeds, dietaryGoals } ];
}
